import moment from "moment";

const fmt = require("indian-number-format");

export default function TradeCard(props) {
  const item = props.item;

  return (
    <div className="menuContainer addHight text">
      <div className="menuExchange">
        {item.script_type === "nse"
          ? "NSE"
          : item.script_type === "mcx"
          ? "MCX"
          : item.script_type === "fo"
          ? "OPTIONS"
          : item.script_type === "nse_cash"
          ? "NSE-EQUITY"
          : item.script_type === "comex_future"
          ? "COMEX"
          : item.script_type === "crypto_future"
          ? "CRYPTO"
          : item.script_type === "forex_future"
          ? "FOREX"
          : "NSE"}
      </div>
      <div className="menuSymbol">{item.symbol}</div>
      <div className="menuExpiry">
        {item.script_type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>
      <div className="menuBuyPrice">{item.qty}</div>
      <div className="menuBuyQty">{item.rate}</div>

      <div
        className={`menuSellQty ${item.buy_sell == 0 ? "buytext" : "selltext"}`}
      >
        {item.buy_sell == 0 ? "BUY" : "SELL"}
      </div>
      <div className="menuSellQty">
        {fmt.format(parseFloat(item.new_deposit).toFixed(0))}
      </div>
      <div className="menuSellQty">
        {fmt.format(parseFloat(item.amount).toFixed(0))}
      </div>

      <div
        className={`menuSymbol small ${
          item.type == "NEW"
            ? "primarytext"
            : item.type == "ADDED"
            ? "buytext"
            : "selltext"
        }`}
      >
        {item.type}
      </div>
      <div className="menuSellQty selltext">
        {fmt.format(parseFloat(item.brokerage_user_amt).toFixed(0))}
      </div>
      <div
        className={`menuOpen ${item.profit_loss > 0 ? "buytext" : "selltext"}`}
      >
        {fmt.format(parseFloat(item.profit_loss).toFixed(0))}
      </div>
      <div
        className="menuLtt small"
        style={{
          textAlign: "center",
          textTransform: "uppercase",
        }}
      >
        {item.other == null ? "-" : item.other}
      </div>
      <div className="menuLtt small">
        {moment(item.date_created).format("DD-MM-YYYY HH:mm:ss")}
      </div>
    </div>
  );
}
